module.exports = __webpack_public_path__ + "static/img/102414.acad90ca.png";